import classNames from 'classnames';
import React from 'react';
import { getYentaImageUrl } from '../utils/ImageUtils.ts';
import {
  isStringPresent,
  parseInitials,
  stringToHexCode,
} from '../utils/StringUtils';

export interface AvatarV2Props {
  name: string;
  imageUrl?: string;
}

const AvatarV2: React.FC<AvatarV2Props> = ({ imageUrl, name }) => {
  return (
    <div
      className={classNames(
        'w-[50px] h-[50px] lg:w-[100px] lg:h-[100px] border-4 border-white rounded-full flex items-center justify-center',
      )}
      style={{
        backgroundColor: !imageUrl ? stringToHexCode(name) : undefined,
      }}
    >
      {isStringPresent(imageUrl) ? (
        <img
          src={getYentaImageUrl(imageUrl)}
          className={classNames('w-full h-full object-cover rounded-full')}
          alt='avatar'
        />
      ) : (
        <p
          className={classNames(
            'text-xl lg:text-5xl font-inter-medium text-white',
          )}
        >
          {parseInitials(name)}
        </p>
      )}
    </div>
  );
};
export default AvatarV2;
